<div *ngIf="havePermission">
    <app-continuous-reservations-filter></app-continuous-reservations-filter>
    <app-continuous-reservations-results></app-continuous-reservations-results>
</div>
